import { FormValidationStatus } from '@customTypes/FormValidationStatus'
import clsx from 'clsx'
import React, { FC, PropsWithChildren } from 'react'
import s from './FormControl.module.scss'
import { useFormControlContext } from './_FormControlContext'
interface Props {
  variant: FormValidationStatus
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type FormControlValidationProps = Props & NativeAttrs

const FormControlValidation: FC<
  PropsWithChildren<FormControlValidationProps>
> = ({ id, variant, className, children, ...props }) => {
  const { validationMessageId } = useFormControlContext()

  return (
    <div className={clsx(s.validationMessage, className)} {...props}>
      <span id={id || validationMessageId || ''}>{children}</span>
    </div>
  )
}

FormControlValidation.displayName = 'FormControlValidation'
export default FormControlValidation
